
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class ApplicantState extends BaseYcState {
  readonly cultureToSaveAfterLogin: string;
  readonly browserLocaleToSaveAfterLogin: string;
}
